// js
import SecurityDetail from '../../components/analytics/SecurityDetail';
import { connect } from 'react-redux';
import { getSecurityOverviewAggregateData, getSecurityOverviewItemizedData } from '../../selectors/analytics/securitySelectors';


export const mapStateToProps = state => {

  return {
    aggregateData: getSecurityOverviewAggregateData(state),
    itemizedData: getSecurityOverviewItemizedData(state)
  };
};

export const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(SecurityDetail);



// WEBPACK FOOTER //
// ./src/containers/analytics/SecurityDetail.js